/**
 * Detects if the current user agent is a bot/crawler
 * This prevents bots from triggering monitoring authentication flows
 *
 * @returns true if the user agent indicates a bot/crawler
 */
export const isBotUserAgent = (): boolean => {
    if (window && window.navigator?.userAgent) {
        const normalizedUserAgent = window.navigator.userAgent.toLowerCase();
        const botPatterns = [
            /bot/i,
            /crawler/i,
            /spider/i,
            /googlebot/i,
            /bingbot/i,
            /slurp/i,
            /facebookexternalhit/i,
            /twitterbot/i,
            /linkedinbot/i,
            /whatsapp/i,
            /skypeuripreview/i,
            /headlesschrome/i,
            /phantomjs/i,
            /selenium/i,
            /webdriver/i,
            /puppeteer/i,
            /playwright/i,
        ];

        return botPatterns.some((pattern) => pattern.test(normalizedUserAgent));
    }
    return false;
};
